import { appSlice } from '../slices';

export const { showSpinner, showSideMenu } = appSlice.actions;
